var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"tv-adv-four-section padd-top-80"},[_c('div',{staticClass:"tv-adv-four-bg"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"tv-adv-four-contain text-center"},[_c('h3',[_vm._v("dont waste life in doubts and fears.")]),_c('p',[_vm._v(" ——emerson")])])])])])
}]

export { render, staticRenderFns }